<template>
  <div class="c-sf-toolbar">
    <div class="c-sf-toolbar__nav">
      <slot name="breadcrumb" />
    </div>

    <div class="c-sf-toolbar__search">
      <SearchIcon
        :width="16"
        :height="16"
        class="c-sf-toolbar__search-icon"
      />
      <input
        :value="value"
        type="text"
        class="form-control"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
        @keyup.enter="$emit('search')"
      >
      <button
        v-if="value"
        type="button"
        class="c-sf-toolbar__clear"
        title="Clear search"
        @click="$emit('clear')"
      >
        <XIcon
          :width="14"
          :height="14"
        />
      </button>
    </div>

    <button
      v-if="showCreateFolder"
      type="button"
      class="c-sf-toolbar__icon"
      title="New folder"
      @click="$emit('create-folder')"
    >
      <FolderPlusIcon
        :width="16"
        :height="16"
      />
    </button>

    <button
      v-if="showFavorites"
      type="button"
      class="c-sf-toolbar__icon"
      :class="{ 'is-active': favoritesActive }"
      :title="favoritesActive ? 'Show all folders' : 'Show favorites only'"
      @click="$emit('toggle-favorites')"
    >
      <BookmarkIcon
        :width="16"
        :height="16"
      />
    </button>
  </div>
</template>

<script>
import { Bookmark as BookmarkIcon, FolderPlus as FolderPlusIcon, Search as SearchIcon, X as XIcon } from 'lucide-vue';

export default {
  name: 'SelectFolderModalToolbar',
  components: { BookmarkIcon, FolderPlusIcon, SearchIcon, XIcon },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
    showCreateFolder: {
      type: Boolean,
      default: false,
    },
    showFavorites: {
      type: Boolean,
      default: false,
    },
    favoritesActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.c-sf-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
}

.c-sf-toolbar__nav {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
}

.c-sf-toolbar__search {
  position: relative;
  flex: 0 0 224px;

  .form-control {
    height: 36px;
    padding-left: 32px;
    padding-right: 32px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 14px;

    &:focus {
      border-color: #16a38b;
      box-shadow: 0 0 0 3px rgba(22, 163, 139, 0.15);
    }

    &::placeholder {
      color: #b1b1b1;
      font-family: "Nunito", sans-serif;
      font-weight: 500;
    }
  }
}

.c-sf-toolbar__search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  // Bootstrap raises the input to z-index 3 on focus, painting over this icon.
  z-index: 4;
  color: #727272;
  pointer-events: none;
}

.c-sf-toolbar__clear {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: none;
  z-index: 4;
  color: #727272;

  &:hover {
    color: rgb(34, 38, 42);
  }
}

.c-sf-toolbar__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: none;
  color: #727272;

  &:hover {
    background-color: #f0f2f4;
    color: rgb(34, 38, 42);
  }

  &.is-active {
    color: rgb(34, 38, 42);

    svg {
      fill: currentColor;
    }
  }
}
</style>
